/* REACT */
import React, { useState, useEffect } from 'react'

/* 3RD PARTIES */
import { connect } from 'react-redux'
import moment from 'moment'
import 'moment/locale/nl'

/* COMPONENTS */

/* STORE */

/* STYLES */
import {
  Title,
  TitleWrapper,
  GridItemWrapper,
  OtherDetailsWrapper,
  OtherSecondaryDetailsWrapper,
  GridItemDetailsWrapper,
  ItemImageWrapper,
  ItemImage,
  TripTypeWrapper,
  TripTypeOnImage,
} from './style'

/* UTILS/CONSTANTS*/
import { CLOUDFRONT_BASE_URL } from '../../../../utils/constants'
import { Analytics } from '../../../../utils'
import { logAction } from '../../../../utils/actionLogger'

/*ASSETS*/
const NoImage = `${CLOUDFRONT_BASE_URL}/assets/images/NoImage.png`

const OtherItem = ({
  index,
  isLessThanLaptop,
  item,
  language,
  key,
  itemsPerRow,
  organizationDetails,
}) => {
  // SET MOMENT LOCALE TO CURRENT LANGUAGE
  moment.locale(language)

  const { name, images, label_image } = item

  const itemImage = images?.length ? images[0]?.url : NoImage

  const mouseDownCoords = e => {
    window.checkForDrag = e.clientX
  }

  if (!organizationDetails?.slug) {
    return null
  }

  return (
    <GridItemWrapper
      target={
        organizationDetails?.openNewTabOnClickthroughGrid ? '_blank' : '_self'
      }
      href={item.url}
      onClick={() => {
        logAction({
          name: 'url_click_grid',
          url: item.url,
          linkLabel: name,
        })
      }}
      itemsPerRow={itemsPerRow}
    >
      <GridItemDetailsWrapper>
        <ItemImageWrapper onMouseDown={e => mouseDownCoords(e)}>
          <ItemImage index={index} backgroundImage={itemImage}>
            {label_image ? (
              <TripTypeWrapper>
                <TripTypeOnImage>{label_image}</TripTypeOnImage>
              </TripTypeWrapper>
            ) : null}
          </ItemImage>
        </ItemImageWrapper>
        <OtherDetailsWrapper>
          {name ? (
            <OtherSecondaryDetailsWrapper>
              {name ? (
                <TitleWrapper>
                  <Title>{name}</Title>
                </TitleWrapper>
              ) : null}
            </OtherSecondaryDetailsWrapper>
          ) : null}
        </OtherDetailsWrapper>
      </GridItemDetailsWrapper>
    </GridItemWrapper>
  )
}

const mapStateToProps = state => ({
  organizationDetails: state?.maya?.organizationDetails,
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(OtherItem)
